/* eslint-disable react/jsx-key */
/* eslint-disable react/prop-types */
import { Box, Grid, Typography, chipClasses } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import RefundTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import { form, AppendixForm } from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal/Modal";
import ModalContent from "./components/modalContent";
import Actions from "./components/actions";
import Tabs from "./components/tabs";
import SelectField from "components/SelectField";
import SoftTypography from "components/SoftTypography";
import Footer from "./components/footer";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import SubTable from "./components/subTable";
import { useEffect } from "react";
const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];
const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};
export default function TaxPaymentExtensionND52() {
  const { formId, formField } = form;
  const { formIdAppendix, formFieldAppendix } = AppendixForm;
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([{ name: "02-1/HT", checked: false }]);
  const [isPeriod, setIsPeriod] = React.useState("firstTime");
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
            isPeriod={isPeriod}
            setIsPeriod={setIsPeriod}
          />
        }
      >
        <Box display="flex" flexDirection="column" pb={10} gap={3}>
          <Box textAlign="center">
            <Typography variant="h4" textTransform="uppercase">
              Giấy đề nghị gia hạn nộp thuế và tiền thuê đất
            </Typography>
          </Box>
          <Formik
            initialValues={initialValues}
            validationSchema={validation}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, isSubmitting, setFieldValue }) => (
              <Form id={formId} autoComplete="off">
                <Fields
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                    isPeriod,
                    setIsPeriod,
                    setFieldValue,
                  }}
                />
                <RefundTable
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                  setFieldValue={setFieldValue}
                />
                <MoreFields
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                />
                <SubTable
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                  setFieldValue={setFieldValue}
                />
                <MoreFields1
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                />
                <Footer
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                />
                <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                  <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
                    {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                  </SoftButton>
                </SoftBox>
              </Form>
            )}
          </Formik>
        </Box>
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const taxType = [
    {
      label: "Thuế GTGT của doanh nghiệp, tổ chức",
      value: "Thuế GTGT của doanh nghiệp, tổ chức",
      checked: false,
    },
    {
      label: "Thuế TNDN của doanh nghiệp, tổ chức",
      value: "Thuế TNDN của doanh nghiệp, tổ chức",
      checked: false,
    },
    {
      label: "Thuế GTGT và thuế TNDN của hộ gia đình, cá nhân kinh doanh",
      value: "Thuế GTGT và thuế TNDN của hộ gia đình, cá nhân kinh doanh",
      checked: false,
    },
    {
      label:
        "Tiền thuê đất (Kê chi tiết địa chỉ tưng khu đất thuê thuộc đối tượng gia hạn tiền thuê trên đất)",
      value:
        "Tiền thuê đất (Kê chi tiết địa chỉ tưng khu đất thuê thuộc đối tượng gia hạn tiền thuê trên đất)",
      checked: false,
    },
  ];
  const { formField, values, errors, touched, isPeriod, setIsPeriod, setFieldValue } = formData;
  const { sendTo, payerName, taxID, agencyName, agencyTax, firstTime, vicarious } = formField;
  const [checked, setChecked] = React.useState(taxType);
  const handleChange = (event, values) => {
    setChecked((prev) => {
      return prev?.map((item) => {
        if (item.value === values) {
          return {
            ...item,
            checked: event.target.checked,
          };
        }
        return item;
      });
    });
  };
  useEffect(() => {
    if (isPeriod === "firstTime") {
      setFieldValue("firstTime", true);
      setFieldValue("vicarious", false);
    } else {
      setFieldValue("vicarious", true);
      setFieldValue("firstTime", false);
    }
  }, [isPeriod, values]);

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField
            name={firstTime.name}
            label={firstTime.label}
            value={values.firstTime}
            onToggle={(e) => e && setIsPeriod("firstTime")}
            defaultValue={isPeriod === "firstTime"}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField
            name={vicarious.name}
            label={vicarious.label}
            value={values.vicarious}
            onToggle={(e) => e && setIsPeriod("vicarious")}
            defaultValue={isPeriod === "vicarious"}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={sendTo.name}
            label={sendTo.label}
            value={values.sendTo}
            error={errors.sendTo && touched.sendTo}
            success={values.sendTo?.toString().length > 0 && !errors.sendTo}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={payerName.name}
            label={payerName.label}
            value={values.payerName}
            error={errors.payerName && touched.payerName}
            success={values.payerName?.toString().length > 0 && !errors.payerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxID.name}
            label={taxID.label}
            value={values.taxID}
            error={errors.taxID && touched.taxID}
            success={values.taxID?.toString().length > 0 && !errors.taxID}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={agencyName.name}
            label={agencyName.label}
            value={values.agencyName}
            error={errors.agencyName && touched.agencyName}
            success={values.agencyName?.toString().length > 0 && !errors.agencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={agencyTax.name}
            label={agencyTax.label}
            value={values.agencyTax}
            error={errors.agencyTax && touched.agencyTax}
            success={values.agencyTax?.toString().length > 0 && !errors.agencyTax}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            [07] Loại thuế đề nghị gia hạn:
          </SoftTypography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
            <div>
              {checked.map((item, i) => (
                <FormControlLabel
                  key={i}
                  label={item.label}
                  control={
                    <Checkbox
                      checked={item?.checked}
                      onChange={(e) => handleChange(e, item.value)}
                    />
                  }
                />
              ))}
            </div>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
function MoreFields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { accountOwner, bankAccountNumber, bankName, attachDocument } = formField;
  const [checked, setChecked] = React.useState([true, false]);
  const handleChange1 = (event) => {
    setChecked([event.target.checked, event.target.checked]);
  };

  const handleChange2 = (event) => {
    setChecked([event.target.checked, checked[1]]);
  };

  const handleChange3 = (event) => {
    setChecked([checked[0], event.target.checked]);
  };
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 30 }}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            [08] Trường hợp được gia hạn
          </SoftTypography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftBox display="flex" flexDirection="column" my={1}>
            <SoftTypography component="label" variant="caption" fontWeight="normal" mb={0.5}>
              I. Doanh nghiệp nhỏ và siêu nhỏ
            </SoftTypography>
          </SoftBox>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
            <div>
              <FormControlLabel
                label="Doanh nghiệp nhỏ"
                control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
              />
              <FormControlLabel
                label="Doanh nghiệp siêu nhỏ"
                control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
              />
            </div>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

function MoreFields1({ formData }) {
  const valueArr = [
    {
      label: "Nông nghiệp, lập nghiệp và thủy sản",
      value: "Nông nghiệp, lập nghiệp và thủy sản",
      checked: false,
    },
    {
      label: "Sản xuất chế biến thực phẩm",
      value: "Sản xuất chế biến thực phẩm",
      checked: false,
    },
    {
      label: "Dệt",
      value: "Dệt",
      checked: false,
    },
    {
      label: "Sản xuất trang phục",
      value: "Sản xuất trang phục",
      checked: false,
    },
    {
      label: "Sản xuất da và những sản phâm có liên quan",
      value: "Sản xuất da và những sản phâm có liên quan",
      checked: false,
    },
    {
      label:
        "Chế biến gỗ và sản xuất sản phẩm từ gỗ, tre, nứa (trừ giường, tủ, bàn, ghế) sản xuất sản phẩm từ rơm ra vật liệu tết bện",
      value:
        "Chế biến gỗ và sản xuất sản phẩm từ gỗ, tre, nứa (trừ giường, tủ, bàn, ghế) sản xuất sản phẩm từ rơm ra vật liệu tết bện",
      checked: false,
    },
    {
      label: "Sản xuất giấy và sẳn phẩm từ giấy",
      value: "Sản xuất giấy và sẳn phẩm từ giấy",
      checked: false,
    },
    {
      label: "Sản xuất các sản phẩm từ cao su và plastic",
      value: "Sản xuất các sản phẩm từ cao su và plastic",
      checked: false,
    },
    {
      label: "Sản xuất các sản phẩm từ khoáng phi kim loại khác",
      value: "Sản xuất các sản phẩm từ khoáng phi kim loại khác",
      checked: false,
    },
    {
      label: "Sản xuất kim loại",
      value: "Sản xuất kim loại",
      checked: false,
    },
    {
      label: "Gia công cơ khí, xử lý và tráng phủ kim loại",
      value: "Gia công cơ khí, xử lý và tráng phủ kim loại",
      checked: false,
    },
    {
      label: "Sản xuất sản phẩm điện tử, máy vi tính và sản phẩm quang học",
      value: "Sản xuất sản phẩm điện tử, máy vi tính và sản phẩm quang học",
      checked: false,
    },
    {
      label: "Sản xuất ô tô và xe có động cơ khác",
      value: "Sản xuất ô tô và xe có động cơ khác",
      checked: false,
    },
    {
      label: "Sản xuất giường tủ bàn ghế",
      value: "Sản xuất giường tủ bàn ghế  ",
      checked: false,
    },
    {
      label: "Xây dựng",
      value: "Xây dựng",
      checked: false,
    },
    {
      label: "Vận tải kho bãi",
      value: "Vận tải kho bãi",
      checked: false,
    },
    {
      label: "Dịch vụ lưu trữ và ăn uống",
      value: "Dịch vụ lưu trữ và ăn uống",
      checked: false,
    },
    {
      label: "Giáo dục và đào tạo",
      value: "Giáo dục và đào tạo",
      checked: false,
    },
    {
      label: "Y tế và hoạt động trợ giúp xã hội",
      value: "Y tế và hoạt động trợ giúp xã hội",
      checked: false,
    },
    {
      label: "Hoạt động kinh doanh bất động sản",
      value: "Hoạt động kinh doanh bất động sản",
      checked: false,
    },
    //
    {
      label: "Hoạt động dịch vụ lao động và việc làm",
      value: "Hoạt động dịch vụ lao động và việc làm",
      checked: false,
    },
    {
      label:
        "Hoạt động của các đại lý du lịch, kinh doanh tua du lịch và các dịch vụ hỗ trợ, liên quan đến quảng bá và tổ chức tua du lịch",
      value:
        "Hoạt động của các đại lý du lịch, kinh doanh tua du lịch và các dịch vụ hỗ trợ, liên quan đến quảng bá và tổ chức tua du lịch",
      checked: false,
    },
    {
      label: "Hoạt động sáng tác, nghệ thuật và giải trí",
      value: "Hoạt động sáng tác, nghệ thuật và giải trí",
      checked: false,
    },
    {
      label: "Hoạt động của thư viện, lưu trữ, bảo tàng và các hoạt động văn hóa khác",
      value: "Hoạt động của thư viện, lưu trữ, bảo tàng và các hoạt động văn hóa khác",
      checked: false,
    },
    {
      label: "Hoạt động thể thao vui chơi giải trí",
      value: "Hoạt động thể thao vui chơi giải trí",
      checked: false,
    },
    {
      label: "Hoạt động chiếu phim",
      value: "Hoạt động chiếu phim",
      checked: false,
    },
    {
      label: "Hoạt động sản xuất sản phẩm công nghiệp hỗ trợ ưu tiên phát triển",
      value: "Hoạt động sản xuất sản phẩm công nghiệp hỗ trợ ưu tiên phát triển",
      checked: false,
    },
    {
      label: "Hoạt động sản xuất sản phẩm cơ khí trọng điểm",
      value: "Hoạt động sản xuất sản phẩm cơ khí trọng điểm",
      checked: false,
    },
    {
      label: "Hoạt động tổ chức tín dụng, chi nhánh ngân hàng nước ngoài",
      value: "Hoạt động tổ chức tín dụng, chi nhánh ngân hàng nước ngoài",
      checked: false,
    },
    {
      label: "Hoạt động xuất bản",
      value: "Hoạt động xuất bản",
      checked: false,
    },
    {
      label: "Hoạt động điện ảnh, sản xuất chương trình truyền hình, ghi âm và sản xuất âm nhạc",
      value: "Hoạt động điện ảnh, sản xuất chương trình truyền hình, ghi âm và sản xuất âm nhạc",
      checked: false,
    },
    {
      label: "Hoạt động phát thanh, truyền hình",
      value: "Hoạt động phát thanh, truyền hình",
      checked: false,
    },
    {
      label: "Hoạt động lập trình máy vi tính,dịch vụ tư vấn và các hoạt động có liên quan đến máy vi tính",
      value: "Hoạt động lập trình máy vi tính,dịch vụ tư vấn và các hoạt động có liên quan đến máy vi tính",
      checked: false,
    },
    {
      label: "Hoạt động dịch vụ thông tin",
      value: "Hoạt động dịch vụ thông tin",
      checked: false,
    },
  ];
  const { formField, values, errors, touched } = formData;
  const { accountOwner, bankAccountNumber, bankName, attachDocument } = formField;
  const [checked, setChecked] = React.useState(valueArr);

  const handleChange = (event, values) => {
    setChecked((prev) => {
      return prev?.map((item) => {
        if (item.value === values) {
          return {
            ...item,
            checked: event.target.checked,
          };
        }
        return item;
      });
    });
  };
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 40 }}>
          <SoftBox display="flex" flexDirection="column" my={1}>
            <SoftTypography component="label" variant="caption" fontWeight="normal" mb={0.5}>
              II. Doanh nghiệp, tổ chức, hộ gia đình, cá nhân kinh doanh hoạt động trong các lĩnh
              vực
            </SoftTypography>
          </SoftBox>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
            <div>
              {checked.map((item, i) => (
                <FormControlLabel
                  key={i}
                  label={item.label}
                  control={
                    <Checkbox
                      checked={item?.checked}
                      onChange={(e) => handleChange(e, item.value)}
                    />
                  }
                />
              ))}
            </div>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
